;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type React from "react";
import Container from "@/components/Container";
import {CMSLink} from "@/components/Link";
import type {CtaBlock as CTABlockProps} from "@/payload-types";
import "./index.css";

export const CTABlock: React.FC<CTABlockProps> = (props) => {
	const { link } = props;

	return (
		<div className="cta-block">
			<Container>{link && <CMSLink {...link} />}</Container>
		</div>
	);
};
